(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-details"] && !Shopify.designMode) return;
  try {
    
function setupBedaDetails(root){
 if(root.dataset.detailsReady)return;root.dataset.detailsReady='true';
 root.querySelectorAll('[data-detail-zoom]').forEach(button=>{
  const setZoom=on=>{button.classList.toggle('is-zoomed',on);button.setAttribute('aria-pressed',String(on))};
  button.addEventListener('click',()=>setZoom(!button.classList.contains('is-zoomed')));
  button.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse')return;const box=button.getBoundingClientRect();button.style.setProperty('--zoom-x',((e.clientX-box.left)/box.width*100)+'%');button.style.setProperty('--zoom-y',((e.clientY-box.top)/box.height*100)+'%')});
  button.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')setZoom(true)});
  button.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')setZoom(false)});
  button.addEventListener('keydown',e=>{if(e.key==='Escape')setZoom(false)});
 });
}
document.querySelectorAll('.bps-details').forEach(setupBedaDetails);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.bps-details').forEach(setupBedaDetails));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-size-finder"] && !Shopify.designMode) return;
  try {
    
function setupBedaSizeFinder(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const form=root.querySelector('form'),category=root.querySelector('[data-size-category]'),size=root.querySelector('[data-size-value]'),button=form.querySelector('button'),status=root.querySelector('[data-size-status]');
  const strings=JSON.parse(root.querySelector('[data-size-strings]').textContent);
  let pending;
  category.addEventListener('change',async()=>{
    if(pending)pending.abort();
    size.replaceChildren(new Option(category.value?strings.loading:strings.first,''));size.disabled=true;button.disabled=true;size.removeAttribute('name');
    if(!category.value){status.textContent=strings.stock;return;}
    form.action=category.value;pending=new AbortController();const controller=pending;
    status.textContent=strings.searching+category.selectedOptions[0].textContent+'…';
    try{
      const url=new URL(category.value,window.location.origin);url.searchParams.set('filter.v.availability','1');url.searchParams.set('section_id','bp-size-options');
      const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('sizes');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const options=Array.from(doc.querySelectorAll('[data-size-options] option'));
      if(controller.signal.aborted)return;
      options.sort((a,b)=>a.textContent.localeCompare(b.textContent,document.documentElement.lang,{numeric:true}));
      size.replaceChildren(new Option(options.length?strings.choose:strings.none,''));
      const groups=new Map();
      options.forEach(option=>{
        const label=option.textContent.replace(/^1 meses$/,'1 mes');
        const groupName=/años|years?/i.test(label)?'years':/meses|mes$|months?/i.test(label)?'months':option.dataset.param.includes('calzado')?'shoes':'other';
        if(!groups.has(groupName)){const group=document.createElement('optgroup');group.label=strings[groupName];groups.set(groupName,group)}
        const item=new Option(label,option.value);item.dataset.param=option.dataset.param;groups.get(groupName).append(item);
      });
      const order=category.selectedOptions[0].dataset.kind==='bebe'?['months','years','shoes','other']:['years','months','shoes','other'];
      order.forEach(name=>{if(groups.has(name))size.append(groups.get(name))});
      size.disabled=!options.length;status.textContent=options.length?strings.stock:strings.empty;
    }catch(error){if(error.name==='AbortError')return;size.replaceChildren(new Option(strings.failed,''));status.textContent=strings.retry;}
  });
  size.addEventListener('change',()=>{const option=size.selectedOptions[0];button.disabled=!size.value;size.name=option?.dataset.param||'';});
  form.addEventListener('submit',event=>{if(!category.value||!size.value||!size.name){event.preventDefault();return;}button.disabled=true;status.textContent=strings.submitting;});
  window.addEventListener('pageshow',()=>{button.disabled=!size.value;});
}
document.querySelectorAll('[data-size-finder]').forEach(setupBedaSizeFinder);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-size-finder]').forEach(setupBedaSizeFinder));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-welcome-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bp-subscription-entry')) {
  customElements.define('bp-subscription-entry', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.link = this.querySelector('a');
      const section = document.getElementById('bp-bienvenida');
      this.formVisible = false;
      this.observer = new IntersectionObserver((entries) => {
        this.formVisible = entries.some((entry) => entry.isIntersecting);
        this.update();
      });
      if (section) this.observer.observe(section);
      this.timer = setInterval(() => this.update(), 1000);
      this.update();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.initialized = false;
    }
    update() {
      const privacy = window.Shopify?.customerPrivacy;
      const cookiePanel = ['shopify-pc__banner', 'shopify-pc__prefs'].some((id) => {
        const element = document.getElementById(id);
        return element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
      });
      const modal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
      let cookiePending = cookiePanel;
      try { cookiePending ||= Boolean(privacy?.shouldShowBanner?.()); } catch { cookiePending = true; }
      const editing = document.activeElement?.closest('input, textarea, select, [contenteditable="true"]');
      this.link.hidden = Boolean(cookiePending || modal || this.formVisible || editing);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-welcome-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bp-welcome-popup')) {
  customElements.define('bp-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.storageKey = 'bp-welcome-5-20261019-v1-hidden-until';
      this.querySelector('.bp-welcome-popup__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.remember(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      const form = this.querySelector('form');
      const signupTags = this.querySelector('[data-bp-signup-tags]');
      const defaultTags = signupTags?.value;
      document.addEventListener('click', (event) => {
        const entry = event.target instanceof Element ? event.target.closest('[data-bp-subscribe-open]') : null;
        if (!entry || this.cookiesPending()) return;
        if (Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => element !== this.dialog && element.getClientRects().length > 0)) return;
        event.preventDefault();
        if (signupTags) signupTags.value = 'newsletter,bienvenida5_20261019,bp_signup_20261025_teaser';
        this.dialog.showModal();
        this.dialog.querySelector('input[type="email"]')?.focus();
        this.remember();
        clearInterval(this.timer);
      }, options);
      if (this.querySelector('[data-welcome-success="true"]') && form && window.location.hash === '#' + form.id) {
        this.dialog.showModal();
        this.remember();
        return;
      }
      try {
        if (Number(localStorage.getItem(this.storageKey)) > Date.now()) return;
      } catch {
        return;
      }
      this.readyAt = Date.now() + Number(this.dataset.delay);
      if (this.dataset.automatic === 'false') return;
      this.quietUntil = 0;
      this.timer = setInterval(() => {
        if (!this.isConnected || document.visibilityState !== 'visible') return;
        if (document.body.hasAttribute('data-bp-floating-busy') || document.querySelector('shopify-chat[open]')) return;
        if (this.cookiesPending()) {
          this.quietUntil = Date.now() + 20000;
          return;
        }
        if (Date.now() < Math.max(this.readyAt, this.quietUntil)) return;
        if (Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden')) return;
        const active = document.activeElement;
        if (active && active.closest('input, textarea, select, [contenteditable="true"]')) return;
        try {
          if (Number(localStorage.getItem(this.storageKey)) > Date.now()) {
            clearInterval(this.timer);
            return;
          }
        } catch {
          clearInterval(this.timer);
          return;
        }
        if (signupTags) signupTags.value = defaultTags;
        this.dialog.showModal();
        this.remember();
        clearInterval(this.timer);
      }, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.initialized = false;
    }
    cookiesPending() {
      const banner = document.getElementById('shopify-pc__banner');
      const preferences = document.getElementById('shopify-pc__prefs');
      if ([banner, preferences].some((element) => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden')) return true;
      try {
        return Boolean(window.Shopify?.customerPrivacy?.shouldShowBanner?.());
      } catch {
        return true;
      }
    }
    remember() {
      try {
        localStorage.setItem(this.storageKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
      } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();
})();
